<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoEditar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card pb-0" *ngIf="permissaoEditar">

			<form>
				<div class="formgroup">
					<div class="flex flex-wrap sm:flex-row justify-content-between"
						*ngIf="caixa && !isExibirSpinnerPrincipal()">
						<div class="flex align-items-center">

							<button pButton pRipple type="button" class="p-button-outlined mr-2"
								pTooltip="Alterar data do Caixa" icon="pi pi-calendar"
								(click)="exibirDialogAlterarDataCaixa = true" style="box-shadow: none;">
							</button>

							<label class="label-inferior text-1xl">
								<strong>{{ caixa.dataCaixa|
									date:'dd/MM/yyyy' }}
								</strong>
							</label>

							<label class="label-inferior ml-2">
								<span class="text-1xl product-badge bg-blue-600 admihair-text-white"
									*ngIf="caixa.status === 'ABERTO'">ABERTO</span>
								<span class="text-1xl product-badge bg-cyan-600 admihair-text-white"
									*ngIf="caixa.status === 'REABERTO'">REABERTO</span>
								<span class="text-1xl product-badge bg-green-600 admihair-text-white"
									*ngIf="caixa.status === 'FECHADO'">FECHADO</span>
							</label>
						</div>
						<div class="flex justify-content-end mt-2 sm:mt-0">
							<button pButton pRipple type="button" class="p-button-primary mr-2" pTooltip="Baixar"
								(click)="baixarRelatorio()"
								[icon]="loadingRelatorioBaixar? 'pi pi-spin pi-spinner':'pi pi-download'"
								style="box-shadow: none;"></button>
							<button pButton pRipple type="button" class="p-button-primary mr-2" pTooltip="Imprimir"
								(click)="imprimirRelatorio()"
								[icon]="loadingRelatorioImprimir? 'pi pi-spin pi-spinner':'pi pi-print'"
								style="box-shadow: none;"></button>

							<button pButton pRipple [pTooltip]="tooltipAcaoCaixa" [label]="labelAcaoCaixa"
								[icon]="loadingSpinnerAcaoCaixa ? 'pi pi-spin pi-spinner': iconeAcaoCaixa"
								[ngClass]="corBotaoAcaoCaixa" (click)="executarAcaoCaixa()">
							</button>
						</div>
					</div>
					<div class="w-full" *ngIf="caixa && !isExibirSpinnerPrincipal()">
						<p-divider></p-divider>
					</div>
					<div class="flex justify-content-center" *ngIf="isExibirSpinnerPrincipal()">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-full mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="caixa && !isExibirSpinnerPrincipal()">

						<div class="col-12 md:col-6 xl:col-3">
							<div style="border: 1px solid #dfe7ef; border-radius: 10px;padding: 10px;"
								class="flex justify-content-between mt-2"
								(click)="carregarDetalharComanda($event,overlayComanda)">
								<div class="flex">
									<span class="font-semibold text-lg mt-2 mr-2">Comandas:</span>
									<span
										class="font-semibold text-lg mt-2"><strong>{{resumoCaixa?.quantidadeTotalComanda}}</strong></span>
								</div>
								<button pButton pRipple type="button" icon="pi pi-angle-down"
									class="p-button-rounded p-button-outlined"></button>
							</div>

						</div>

						<div class="col-12 md:col-6 xl:col-3">
							<div style="border: 1px solid #dfe7ef; border-radius: 10px;padding: 10px;"
								class="flex justify-content-between mt-2"
								(click)="carregarDetalharConta($event,overlayContaCaixa, 'CAIXA')">
								<div class="flex">
									<span class="font-semibold text-lg mt-2 mr-2">Caixa:</span>
									<span class="font-semibold text-lg mt-2"><strong>{{resumoCaixa?.valorTotalContaCaixa
											| currency:'BRL'}}</strong></span>

								</div>
								<button pButton pRipple type="button" icon="pi pi-angle-down"
									class="p-button-rounded p-button-outlined"></button>
							</div>

						</div>

						<div class="col-12 md:col-6 xl:col-3">
							<div style="border: 1px solid #dfe7ef; border-radius: 10px;padding: 10px;"
								class="flex justify-content-between mt-2"
								(click)="carregarDetalharConta($event,overlayContaBanco, 'BANCO')">
								<div class="flex">
									<span class="font-semibold text-lg mt-2 mr-2">Banco:</span>
									<span class="font-semibold text-lg mt-2"><strong>{{resumoCaixa?.valorTotalContaBanco
											| currency:'BRL'}}</strong></span>

								</div>
								<button pButton pRipple type="button" icon="pi pi-angle-down"
									class="p-button-rounded p-button-outlined"></button>
							</div>

						</div>

						<div class="col-12 md:col-6 xl:col-3">
							<div style="border: 1px solid #dfe7ef; border-radius: 10px;padding: 10px;"
								class="flex justify-content-between mt-2"
								(click)="carregarDetalharConta($event,overlayContaAjuste, 'AJUSTE')">
								<div class="flex">
									<span class="font-semibold text-lg mt-2 mr-2">Ajustes:</span>
									<span class="font-semibold text-lg mt-2"><strong>{{resumoCaixa?.valorTotalContaAjuste
											| currency:'BRL'}}</strong></span>

								</div>
								<button pButton pRipple type="button" icon="pi pi-angle-down"
									class="p-button-rounded p-button-outlined"></button>
							</div>

						</div>
						<div class="col-12">
							<div class="w-full">
								<h6>Comandas</h6>
							</div>
							<p-table #dt1 [value]="listaComandas" dataKey="id" [loading]="loadingTable"
								[rowHover]="true" [paginator]="false" responsiveLayout="stack"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="caption">
									<div class="formgroup">
										<div class="flex justify-content-between flex-column sm:flex-row">
											<div class="flex flex-column sm:flex-row w-full">
												<div class="p-fluid sm:mr-2">
													<label>
														<i class="pi pi-sliders-h"></i>
														Status
													</label>
													<p-dropdown [options]="listaSitucoesStatus"
														emptyFilterMessage="Nenhum registro" name="situacao" ngModel
														#situacao="ngModel" [(ngModel)]="statusComandaSelecionado"
														(onChange)="listarRelatorioComandas()"
														emptyMessage="Nenhum registro">
													</p-dropdown>
												</div>
												<div class="p-fluid mt-2 sm:mt-0">
													<label>
														<i class="pi pi-user"></i>
														Usuário
													</label>
													<p-dropdown [options]="usuariosSelectItem" optionLabel="label"
														optionValue="value" emptyFilterMessage="Nenhum registro"
														name="situacao" ngModel #situacao="ngModel"
														[(ngModel)]="usuarioSelecionado"
														(onChange)="listarRelatorioComandas()">
													</p-dropdown>
												</div>
											</div>
											<div class="flex justify-content-end flex-column sm:flex-row">
												<div class="p-fluid w-full sm:w-auto">
													<div class="flex mt-3 sm:mt-4">
														<span class="p-input-icon-left">
															<i class="pi pi-search"></i>
															<input pInputText type="text" #filter
																(input)="buscar( $event)" placeholder="Buscar"
																class="w-full" />
														</span>
														<span class="ml-2">
															<button pButton class="p-button-outlined"
																icon="pi pi-filter-slash" pTooltip="Limpar Filtros"
																(click)="limpar()"></button>
														</span>
													</div>

												</div>

											</div>
										</div>
									</div>
								</ng-template>
								<ng-template pTemplate="header">
									<tr>
										<th pSortableColumn="numeroComanda">
											Nº Comanda
											<p-sortIcon field="numeroComanda">
											</p-sortIcon>
										</th>
										<th pSortableColumn="cliente.nome">
											Cliente
											<p-sortIcon field="cliente.nome">
											</p-sortIcon>
										</th>

										<th pSortableColumn="statusComanda">
											Status
											<p-sortIcon field="statusComanda">
											</p-sortIcon>
										</th>
										<th>
											Total Nota
										</th>
										<th pSortableColumn="totalFluxo">
											Fechamento
											<p-sortIcon field="totalFluxo">
											</p-sortIcon>
										</th>
										<th>
											Conta do Cliente
										</th>
										<th pSortableColumn="nomeOperador">
											Operador
											<p-sortIcon field="nomeOperador">
											</p-sortIcon>
										</th>
										<th style="text-align: center;">
											Ações
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.numeroComanda}}
										</td>
										<td>
											{{item.nomeCliente}}
										</td>
										<td>
											<span class="product-badge bg-blue-600 admihair-text-white"
												*ngIf="item.statusComanda === 'ABERTA'">ABERTA</span>
											<span class="product-badge bg-cyan-600 admihair-text-white"
												*ngIf="item.statusComanda === 'REABERTA'">REABERTA</span>
											<span class="product-badge bg-green-600 admihair-text-white"
												*ngIf="item.statusComanda === 'FECHADA'">FECHADA</span>
											<span class="product-badge bg-red-600 admihair-text-white"
												*ngIf="item.statusComanda === 'CANCELADA'">CANCELADA</span>

										</td>
										<td>
											{{(item.totalMovimento) | currency:'BRL' }}
										</td>
										<td>
											{{item.totalFluxo | currency:'BRL' }}
										</td>
										<td *ngIf="item.situacaoFechamento === 'NORMAL'">
											{{item.contaCliente | currency:'BRL' }} - NORMAL
										</td>
										<td *ngIf="item.situacaoFechamento === 'ENTRADA_CREDITO'">
											{{item.contaCliente | currency:'BRL' }} - ENTRADA CRÉDITO
										</td>
										<td *ngIf="item.situacaoFechamento === 'ENTRADA_DEBITO'">
											{{item.contaCliente | currency:'BRL' }} - ENTRADA DÉBITO
										</td>
										<td *ngIf="item.situacaoFechamento === 'PAGAMENTO_DEBITO'">
											{{item.contaCliente | currency:'BRL' }} - PAGAMENTO DÉBITO
										</td>
										<td *ngIf="item.situacaoFechamento === 'UTILIZACAO_CREDITO'">
											{{item.contaCliente | currency:'BRL' }} - UTILIZAÇÃO CRÉDITO
										</td>
										<td>
											{{item.nomeOperador}}
										</td>
										<td style="text-align: center;">
											<button pButton pRipple icon="pi pi-eye" pTooltip="Detalhar Comanda"
												(click)="openComandaResumo(item.comandaId)"
												class="p-button-info mr-2 mb-2"></button>
											<button *ngIf="item.statusComanda === 'FECHADA'" pButton pRipple
												pTooltip="Reabrir Comanda" icon="pi pi-replay"
												class="p-button-success mr-2 mb-2"
												(click)="reabrirComanda(item.comandaId)"></button>
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="footer">
									<tr>
										<td>
										</td>
										<td>
										</td>
										<td>

										</td>
										<td>
											{{ (listaComandas | totalizarCampo:'totalMovimento') | currency:'BRL' }}
										</td>
										<td>
											{{ (listaComandas | totalizarCampo:'totalFluxo') | currency:'BRL' }}
										</td>
										<td>

										</td>
										<td>

										</td>
										<td>

										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro encontrado.</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="loadingbody">
									<tr>
										<td colspan="7">Carregando clientes. Por favor aguarde.</td>
									</tr>
								</ng-template>
							</p-table>

						</div>
						<div class="col-12">
							<div class="w-full">
								<h6>Despesas</h6>
							</div>
							<p-table #dt2 [value]="listaDespesasCaixa" dataKey="id" [loading]="loadingTableDespesas"
								[rowHover]="true" [paginator]="false" responsiveLayout="stack"
								styleClass=" p-datatable-sm">
								<ng-template pTemplate="header">
									<tr>
										<th pSortableColumn="identificacao">
											Despesa
											<p-sortIcon field="identificacao">
											</p-sortIcon>
										</th>
										<th pSortableColumn="operador">
											Operador
											<p-sortIcon field="operador">
											</p-sortIcon>
										</th>

										<th>
											Valor pago
										</th>

									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.identificacao}}
										</td>
										<td>
											{{item.operador}}
										</td>
										<td>
											{{(item.valor) | currency:'BRL' }}
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="footer">
									<tr>
										<td>
										</td>
										<td>

										</td>
										<td>
											{{ totalDespesas | currency:'BRL' }}
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro encontrado.</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="loadingbody">
									<tr>
										<td colspan="7">Carregando clientes. Por favor aguarde.</td>
									</tr>
								</ng-template>
							</p-table>

						</div>
						<div class="col-12">
							<div class="w-full">
								<h6>Transferências</h6>
							</div>
							<p-table #dt3 [value]="listaTransferenciasCaixa" dataKey="id"
								[loading]="loadingTableTransferencias" [rowHover]="true" [paginator]="false"
								responsiveLayout="stack" styleClass=" p-datatable-sm">
								<ng-template pTemplate="header">
									<tr>
										<th pSortableColumn="origem">
											Origem
											<p-sortIcon field="origem">
											</p-sortIcon>
										</th>
										<th pSortableColumn="destino">
											Destino
											<p-sortIcon field="destino">
											</p-sortIcon>
										</th>
										<th pSortableColumn="operador">
											Operador
											<p-sortIcon field="operador">
											</p-sortIcon>
										</th>

										<th>
											Valor
										</th>

									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.origem}}
										</td>
										<td>
											{{item.destino}}
										</td>
										<td>
											{{item.operador}}
										</td>
										<td>
											{{(item.valor) | currency:'BRL' }}
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="footer">
									<tr>
										<td>
										</td>
										<td>
										</td>
										<td>
										</td>
										<td>
											{{ totalTransferencias | currency:'BRL' }}
										</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum registro encontrado.</td>
									</tr>
								</ng-template>
								<ng-template pTemplate="loadingbody">
									<tr>
										<td colspan="7">Carregando. Por favor aguarde.</td>
									</tr>
								</ng-template>
							</p-table>

						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!isExibirSpinnerPrincipal()">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem mt-5" routerLink="/apps/caixa-gerenciar"></button>
						</div>
					</div>

					<p-overlayPanel #overlayComanda [showCloseIcon]="true" [style]="{ backgroundColor: '#f5f5f5'}">
						<ng-template pTemplate>
							<div class="flex justify-content-center" *ngIf="exibirSpinnerDetalhes">
								<p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
									strokeWidth="8" fill="var(--surface-ground)"
									animationDuration=".5s"></p-progressSpinner>
							</div>
							<div *ngIf="!exibirSpinnerDetalhes">
								<p-table #tbDetalheComanda [value]="detalhesComanda" dataKey="id" [rowHover]="true"
									[paginator]="false" responsiveLayout="scroll" styleClass="p-datatable-striped">
									<ng-template pTemplate="header">
										<tr>
											<th>Status</th>
											<th>Quantidade</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												<span class="product-badge bg-blue-600 admihair-text-white"
													*ngIf="item.descricao === 'ABERTA'">ABERTA</span>
												<span class="product-badge bg-cyan-600 admihair-text-white"
													*ngIf="item.descricao === 'REABERTA'">REABERTA</span>
												<span class="product-badge bg-green-600 admihair-text-white"
													*ngIf="item.descricao === 'FECHADA'">FECHADA</span>
												<span class="product-badge bg-red-600 admihair-text-white"
													*ngIf="item.descricao === 'CANCELADA'">CANCELADA</span>
											</td>
											<td>
												<label>{{ item.quantidade }}</label>
											</td>

										</tr>

									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Nenhum registro encontrado.</td>
										</tr>
									</ng-template>
								</p-table>
							</div>
						</ng-template>
					</p-overlayPanel>
					<p-overlayPanel #overlayContaCaixa [showCloseIcon]="true" [style]="{backgroundColor: '#f5f5f5'}">
						<ng-template pTemplate>

							<div class="flex justify-content-center" *ngIf="exibirSpinnerDetalhes">
								<p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
									strokeWidth="8" fill="var(--surface-ground)"
									animationDuration=".5s"></p-progressSpinner>
							</div>
							<div *ngIf="!exibirSpinnerDetalhes">
								<p-table #tbDetalheConta [value]="detalhesConta" dataKey="id" [rowHover]="true"
									[paginator]="false" responsiveLayout="scroll" styleClass="p-datatable-striped">
									<ng-template pTemplate="header">
										<tr>
											<th>Descrição</th>
											<th>Valor</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												<label class="product-badge bg-green-600 admihair-text-white">{{
													item.descricao }}
												</label>
											</td>
											<td>
												<label>{{ item.valor | currency:'BRL' }}</label>
											</td>
										</tr>

									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Nenhum registro encontrado.</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="summary">
										<div class="flex align-items-center justify-content-end">

											<div class="flex-column hidden md:flex">
												Total: {{valorTotalDetalheConta | currency:'BRL'}}
											</div>
										</div>
									</ng-template>
								</p-table>
							</div>
						</ng-template>
					</p-overlayPanel>
					<p-overlayPanel #overlayContaBanco [showCloseIcon]="true" [style]="{backgroundColor: '#f5f5f5'}">
						<ng-template pTemplate>

							<div class="flex justify-content-center" *ngIf="exibirSpinnerDetalhes">
								<p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
									strokeWidth="8" fill="var(--surface-ground)"
									animationDuration=".5s"></p-progressSpinner>
							</div>
							<div *ngIf="!exibirSpinnerDetalhes">
								<p-table #tbDetalheConta [value]="detalhesConta" dataKey="id" [rowHover]="true"
									[paginator]="false" responsiveLayout="scroll" styleClass="p-datatable-striped">
									<ng-template pTemplate="header">
										<tr>
											<th>Descrição</th>
											<th>Valor</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												<label class="product-badge bg-green-600 admihair-text-white">{{
													item.descricao }}
												</label>
											</td>
											<td>
												<label>{{ item.valor | currency:'BRL' }}</label>
											</td>
										</tr>

									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Nenhum registro encontrado.</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="summary">
										<div class="flex align-items-center justify-content-end">

											<div class="flex-column hidden md:flex">
												Total: {{valorTotalDetalheConta | currency:'BRL'}}
											</div>
										</div>
									</ng-template>
								</p-table>
							</div>
						</ng-template>
					</p-overlayPanel>
					<p-overlayPanel #overlayContaAjuste [showCloseIcon]="true" [style]="{ backgroundColor: '#f5f5f5'}">
						<ng-template pTemplate>

							<div class="flex justify-content-center" *ngIf="exibirSpinnerDetalhes">
								<p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
									strokeWidth="8" fill="var(--surface-ground)"
									animationDuration=".5s"></p-progressSpinner>
							</div>
							<div *ngIf="!exibirSpinnerDetalhes">
								<p-table #tbDetalheConta [value]="detalhesConta" dataKey="id" [rowHover]="true"
									[paginator]="false" responsiveLayout="scroll" styleClass="p-datatable-striped">
									<ng-template pTemplate="header">
										<tr>
											<th>Descrição</th>
											<th>Valor</th>
										</tr>
									</ng-template>
									<ng-template pTemplate="body" let-item let-i="rowIndex">
										<tr>
											<td>
												<label class="product-badge bg-green-600 admihair-text-white">{{
													item.descricao }}
												</label>
											</td>
											<td>
												<label>{{ item.valor | currency:'BRL' }}</label>
											</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="emptymessage">
										<tr>
											<td colspan="7">Nenhum registro encontrado.</td>
										</tr>
									</ng-template>
									<ng-template pTemplate="summary">
										<div class="flex align-items-center justify-content-end">

											<div class="flex-column hidden md:flex">
												Total: {{valorTotalDetalheConta | currency:'BRL'}}
											</div>
										</div>
									</ng-template>
								</p-table>
							</div>
						</ng-template>
					</p-overlayPanel>

				</div>
			</form>
			<div class="w-full mb-2 flex flex-wrap sm:flex-row" *ngIf="caixa && !exibirSpinnerPrincipal">
				<span class="text-sm font-medium font-italic mr-2">
					Abertura: {{ caixa.dataCriacao | date:'dd/MM/yyyy HH:mm:ss' }}
				</span>
				<span class="text-sm font-medium font-italic mr-2">
					Última alteração: {{ caixa.dataAtualizacao | date:'dd/MM/yyyy HH:mm:ss' }}
				</span>
				<span class="text-sm font-medium font-italic">
					Usuário: {{ caixa.usuario?.apelido }}
				</span>
			</div>
			<p-confirmDialog [style]="{width: '50vw'}">
			</p-confirmDialog>
			<p-dialog header="Alterar Data Caixa" [(visible)]="exibirDialogAlterarDataCaixa" [modal]="true"
				[draggable]="false" [resizable]="false" [closable]="true">
				<div class="card">
					<div class="formgroup">
						<div class="p-fluid p-formgrid grid justify-content-between">
							<div class="field col-12 md:col-12">
								<label for="">Data Caixa</label>
								<p-calendar [readonlyInput]="false" [showIcon]="true" dateFormat="dd/mm/yy"
									[showButtonBar]="false" ngModel [(ngModel)]="novaDataCaixaSelecionada"
									[maxDate]="dataAtual" appendTo="body" placeholder="Selecione">
								</p-calendar>
							</div>
						</div>
					</div>

				</div>
				<p-footer>
					<div class="flex justify-content-between">
						<button type="button" pButton
							[icon]="loadingSpinnerAlterarDataCaixa ? 'pi pi-spin pi-spinner':'pi pi-check'"
							label="Confirmar" class="p-button-success mt-2" (click)="alterarDataCaixa()"
							[disabled]="loadingSpinnerAlterarDataCaixa"></button>
						<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
							(click)="exibirDialogAlterarDataCaixa = false"
							[disabled]="loadingSpinnerAlterarDataCaixa"></button>
					</div>
				</p-footer>
			</p-dialog>
		</div>

	</div>
</div>